import axios from '@/utils/request'
import base from '@/api/base'

/**
 * 知识库（/v1/knowledge/**）
 */

/* ===== 分类 ===== */
export function listCategories(params) {
  return axios.get(`${base.url}/service/v1/knowledge/categories`, { params })
}
export function createCategory(data) {
  return axios.post(`${base.url}/service/v1/knowledge/categories`,
    JSON.stringify(data), { headers: { 'Content-Type': 'application/json' } })
}
export function updateCategory(id, data) {
  return axios.put(`${base.url}/service/v1/knowledge/categories/${id}`,
    JSON.stringify(data), { headers: { 'Content-Type': 'application/json' } })
}
export function deleteCategory(id) {
  return axios.delete(`${base.url}/service/v1/knowledge/categories/${id}`)
}

/* ===== 文章 ===== */
export function listArticles(params) {
  return axios.get(`${base.url}/service/v1/knowledge/articles`, { params })
}
export function createArticle(data) {
  return axios.post(`${base.url}/service/v1/knowledge/articles`,
    JSON.stringify(data), { headers: { 'Content-Type': 'application/json' } })
}
export function updateArticle(id, data) {
  return axios.put(`${base.url}/service/v1/knowledge/articles/${id}`,
    JSON.stringify(data), { headers: { 'Content-Type': 'application/json' } })
}
export function deleteArticle(id) {
  return axios.delete(`${base.url}/service/v1/knowledge/articles/${id}`)
}

/* ===== 批量 ===== */
export function downloadArticleTemplate() {
  return axios.get(`${base.url}/service/v1/knowledge/articles/template`, { responseType: 'blob' })
}
export function importArticles(file) {
  const fd = new FormData()
  fd.append('file', file)
  return axios.post(`${base.url}/service/v1/knowledge/articles/import`, fd,
    { headers: { 'Content-Type': 'multipart/form-data' } })
}
export function batchDeleteArticles(ids) {
  return axios.delete(`${base.url}/service/v1/knowledge/articles/batch`,
    { headers: { 'Content-Type': 'application/json' }, data: JSON.stringify({ ids }) })
}
export function exportArticles() {
  return axios.get(`${base.url}/service/v1/knowledge/articles/export`, { responseType: 'blob' })
}

/* ===== 预览导入 ===== */
export function previewImportArticles(file) {
  const fd = new FormData()
  fd.append('file', file)
  return axios.post(`${base.url}/service/v1/knowledge/articles/import/preview`, fd,
    { headers: { 'Content-Type': 'multipart/form-data' } })
}
export function executeImportArticles(items) {
  return axios.post(`${base.url}/service/v1/knowledge/articles/import/execute`,
    JSON.stringify({ items }), { headers: { 'Content-Type': 'application/json' } })
}